module.exports = __webpack_public_path__ + "img/br17.1bf20d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br17.jpg
// module id = X7rI
// module chunks = 0